(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.ci-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Hero slider ---------- */
  function initHero(hero) {
    if (!hero || hero.dataset.ready) return;
    hero.dataset.ready = '1';
    var slides = hero.querySelectorAll('.ci-hero__slide');
    var dots = hero.querySelectorAll('.ci-hero__dot');
    var count = hero.querySelector('.ci-hero__count b');
    var delay = parseInt(hero.dataset.delay || '6000', 10);
    hero.style.setProperty('--ci-dur', delay + 'ms');
    var i = 0, timer = null;

    function go(n) {
      slides[i].classList.remove('is-active');
      dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) { dots[i].classList.remove('is-active'); void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
      if (count) count.textContent = ('0' + (i + 1)).slice(-2);
      restart();
    }
    function restart() { clearTimeout(timer); timer = setTimeout(function () { go(i + 1); }, delay); }

    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    var prev = hero.querySelector('[data-ci-prev]'), next = hero.querySelector('[data-ci-next]');
    prev && prev.addEventListener('click', function () { go(i - 1); });
    next && next.addEventListener('click', function () { go(i + 1); });

    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? clearTimeout(timer) : restart(); });
    if (dots[0]) dots[0].classList.add('is-active');
    restart();
  }

  /* ---------- Tabs (product grid) ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-ci-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var tabs = wrap.querySelectorAll('.ci-tab'), panels = wrap.querySelectorAll('.ci-panel');
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); });
          panels.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active'); panels[n].classList.add('is-active');
          initReveal(panels[n]);
        });
      });
    });
  }

  /* ---------- Parallax banner ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-ci-parallax]');
    if (!els.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.transform = 'translate3d(0,' + (p * -60).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Count-up numbers ---------- */
  function initCount() {
    document.querySelectorAll('[data-ci-count]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var end = parseInt(el.dataset.ciCount, 10), suffix = el.dataset.suffix || '';
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var t0 = null;
        function step(ts) { if (!t0) t0 = ts; var k = Math.min((ts - t0) / 1400, 1); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + suffix; if (k < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
      io.observe(el);
    });
  }

  /* ---------- Back to top ---------- */
  function initTop() {
    if (document.querySelector('.ci-top')) return;
    var b = document.createElement('button');
    b.className = 'ci-top'; b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);
    window.addEventListener('scroll', function () { b.classList.toggle('is-show', window.scrollY > 700); }, { passive: true });
  }

  function boot(root) {
    document.querySelectorAll('[data-ci-hero]').forEach(initHero);
    initTabs(root); initReveal(root); initCount();
  }
  document.addEventListener('DOMContentLoaded', function () { boot(); initParallax(); initTop(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); initParallax(); });
})();
